import styled from "styled-components/macro";
import { InputSwitch, ButtonText, PrimaryButton, SecondaryButton } from "@loanbossinc/component-library";
import TextField from "@material-ui/core/TextField";

export const IntegrationsWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
export const VendorsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 1.5em;
`;

export const VendorWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 200px;
  border: 1px solid #dadce0;
  border-left: none;
  padding: 0.5em 1em;

  &:nth-child(1) {
    border-left: 1px solid #dadce0;
  }
`;

export const Header = styled.div`
  font-family: Work Sans;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
  margin-bottom: 1.5em;
`;

export const SubHeader = styled.div`
  font-family: Work Sans;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 23px;
  margin-bottom: 1em;
`;

export const VendorName = styled.div`
  font-family: Work Sans;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
`;

export const StyledSwitch = styled(InputSwitch)`
  & .Mui-checked {
    color: #2c98f0 !important;
  }
`;

export const Description = styled.div`
  font-family: Work Sans;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: #5f6368;
  margin-bottom: 1em;
`;

export const LRWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 22.5em;
  border: 1px solid #dadce0;
  padding: 0.5em 1em;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 1.5em;
`;

export const StyledField = styled(TextField)`
  background: #e8e8e8;
  width: 20em;

  label {
    padding: 8px 18px;
    color: #999999;
  }

  input {
    padding: 10px 12px;
    color: ${props => props.isEmpty && "rgba(0, 0, 0, 0.56)"};
  }
`;

export const DateButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1em;
`;

export const RentCodeItemWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1em;
`;

export const StyledButtonText = styled(ButtonText)`
  && {
    color: #C40A0A;
    font-size: 16px;

    .material-icons {
      margin-left: 0 !important;
      margin-right: 5px !important;
      transform: rotate(0deg) !important;
    }
  }
`;

export const StyledPrimaryButton = styled(PrimaryButton)`
  && {
    font-size: 14px;
    width: 10em;
    padding: 0;
  }
`;

export const StyledSecondaryButton = styled(SecondaryButton)`
  && {
    font-size: 14px;
    width: 10em;
    padding: 0;
  }
`;
